<template>
  <v-layout wrap>
    <v-flex
      v-if="
        getCreditsQuestions.informal_liability_reason.informal_liability_details.hasOwnProperty(
          'liability_amount'
        )
      "
      xs12
    >
      <v-layout align-center>
        <v-flex
          xs9
          md7
          lg3
          class="mb-2"
        >
          <v-text-field
            v-model="informalLiabilityDetails.liabilityAmount"
            v-validate="{
              ...requiredMoney(
                getCreditsQuestions.informal_liability_reason.informal_liability_details
                  .liability_amount.required
              )
            }"
            :label="
              getCreditsQuestions.informal_liability_reason.informal_liability_details
                .liability_amount.label
            "
            :error-messages="errors.collect('liabilityAmount')"
            :data-vv-as="$t('sheet.sheetOne.meeting.credits.labels.credit_amount')"
            :data-vv-name="'liabilityAmount'"
            :required="
              getCreditsQuestions.informal_liability_reason.informal_liability_details
                .liability_amount.required
            "
            class="pt-0 mt-3"
            :disabled="readOnly"
            inputmode="decimal"
          />
        </v-flex>
        <v-flex
          xs3
          md5
          lg2
          shrink
          justify-center
          ml-3
        >
          <v-subheader
            class="px-0 pt-1"
            :class="{
              required:
                getCreditsQuestions.informal_liability_reason.informal_liability_details
                  .liability_amount.required
            }"
          >
            {{ $t('label.currency') }}
          </v-subheader>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      v-if="
        getCreditsQuestions.informal_liability_reason.informal_liability_details.hasOwnProperty(
          'liability_remains_to_repair'
        )
      "
      xs12
    >
      <v-layout align-center>
        <v-flex
          xs9
          md7
          lg3
        >
          <v-text-field
            v-model="informalLiabilityDetails.liabilityRemainsToRepair"
            v-validate="{
              ...requiredMoney(
                getCreditsQuestions.informal_liability_reason.informal_liability_details
                  .liability_remains_to_repair.required
              )
            }"
            :label="
              getCreditsQuestions.informal_liability_reason.informal_liability_details
                .liability_remains_to_repair.label
            "
            :error-messages="errors.collect('liabilityRemainsToRepair')"
            :data-vv-as="$t('sheet.sheetOne.meeting.credits.labels.remains_to_repair')"
            :data-vv-name="'liabilityRemainsToRepair'"
            :required="
              getCreditsQuestions.informal_liability_reason.informal_liability_details
                .liability_remains_to_repair.required
            "
            class="pt-0 mt-2"
            :disabled="readOnly"
            inputmode="decimal"
          />
        </v-flex>
        <v-flex
          xs3
          md5
          lg2
          shrink
          justify-center
          ml-3
        >
          <v-subheader
            class="px-0 pt-1"
            :class="{
              required:
                getCreditsQuestions.informal_liability_reason.informal_liability_details
                  .liability_remains_to_repair.required
            }"
          >
            {{ $t('label.currency') }}
          </v-subheader>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      v-if="
        getCreditsQuestions.informal_liability_reason.informal_liability_details.hasOwnProperty(
          'liability_year'
        )
      "
      xs12
    >
      <v-layout align-center>
        <v-flex
          xs9
          md7
          lg3
          class="mb-2"
        >
          <v-select
            v-model="informalLiabilityDetails.liabilityYear"
            :items="years"
            :label="
              getCreditsQuestions.informal_liability_reason.informal_liability_details
                .liability_year.label
            "
            append-icon="expand_more"
            :disabled="readOnly"
          />
        </v-flex>
        <v-flex
          xs3
          md5
          lg2
          shrink
          justify-center
          ml-3
        >
          <v-subheader
            v-if="
              !getCreditsQuestions.informal_liability_reason.informal_liability_details
                .liability_year.required
            "
            class="px-0 pt-1"
          >
            {{ $t('message.optional') }}
          </v-subheader>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      v-if="
        getCreditsQuestions.informal_liability_reason.informal_liability_details.hasOwnProperty(
          'month_liability_amount'
        )
      "
      xs12
    >
      <v-layout align-center>
        <v-flex
          xs9
          md7
          lg3
        >
          <v-text-field
            v-model="informalLiabilityDetails.monthLiabilityAmount"
            v-validate="{
              ...requiredMoney(
                getCreditsQuestions.informal_liability_reason.informal_liability_details
                  .month_liability_amount.required
              )
            }"
            :label="
              getCreditsQuestions.informal_liability_reason.informal_liability_details
                .month_liability_amount.label
            "
            :error-messages="errors.collect('month_liability_amount')"
            :data-vv-as="$t('sheet.sheetOne.meeting.credits.labels.amount')"
            :data-vv-name="'month_liability_amount'"
            :required="
              getCreditsQuestions.informal_liability_reason.informal_liability_details
                .month_liability_amount.required
            "
            class="pt-0 mt-2"
            :disabled="readOnly"
            inputmode="decimal"
          />
        </v-flex>
        <v-flex
          xs3
          md5
          lg2
          shrink
          justify-center
          ml-3
        >
          <v-subheader
            class="px-0 pt-1"
            :class="{
              required:
                getCreditsQuestions.informal_liability_reason.informal_liability_details
                  .month_liability_amount.required
            }"
          >
            {{ $t('label.amount_suffix') }}
          </v-subheader>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import validationRules from '@/constants/validationRules';
import credits from '@/constants/sheet/credits';
import formatDecimalVariables from '@/mixins/formatDecimalVariables';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

const { mapFields } = createHelpers({
    getterType: 'sheet/getCreditsField',
    mutationType: 'sheet/updateCreditsField'
});

export default {
    name: 'InformalLiabilityForm',
    mixins: [formatDecimalVariables, sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            credits
        };
    },
    computed: {
        ...mapFields(['informalLiabilityDetails']),
        ...mapGetters('sheet', ['getCreditsQuestions']),
        years () {
            return this.credits.YEARS(
                this.getCreditsQuestions.credit_details.credit_year.range.min,
                this.getCreditsQuestions.credit_details.credit_year.range.max
            );
        }
    },
    beforeDestroy () {
        this.informalLiabilityDetails = {
            liabilityAmount: null,
            liabilityRemainsToRepair: null,
            liabilityYear: null,
            monthLiabilityAmount: null
        };
    }
};
</script>

<style scoped></style>
